// extracted by mini-css-extract-plugin
export default {"profile__info":"DetailForm_profile__info__2eZ4v"};